export const IDGOV_CONFIG = {
  baseUrl: import.meta.env.VITE_IDGOV_URL,
  clientId: import.meta.env.VITE_IDGOV_CLIENT_ID,
  redirectUri: import.meta.env.VITE_IDGOV_REDIRECT_URI,
  authTypes: import.meta.env.VITE_IDGOV_AUTH_TYPES,
  backendAuthUrl: import.meta.env.VITE_BACKEND_AUTH_URL,
} as const;

export const IDGOV_ENDPOINTS = {
  authorize: "/",
  getAccessToken: "/get-access-token",
  getUserInfo: "/get-user-info",
  refreshToken: "/get-refresh-token",
  logout: "/get-user-logout",
} as const;

export const AUTH_TYPES = {
  ELECTRONIC_SIGNATURE: "dig_sign",
  DIIA_SIGNATURE: "diia_id",
  BANK_ID: "bank_id",
  DIIA_OAUTH: "diia_oauth",
} as const;

export const IDGOV_ERROR_CODES: Record<number, string> = {
  1: "Невірний формат ідентифікатора клієнта. Зверніться до адміністратора.",
  2: "Невірний формат секретного ключа. Зверніться до адміністратора.",
  3: "Невірний формат коду авторизації. Спробуйте увійти ще раз.",
  4: "Час на авторизацію вичерпано (30 секунд). Будь ласка, спробуйте ще раз.",
  5: "Невірний формат токену доступу. Спробуйте увійти ще раз.",
  6: "Токен доступу прострочений. Будь ласка, увійдіть знову.",
  7: "Невірний формат токену оновлення. Увійдіть знову.",
  8: "Токен оновлення прострочений. Будь ласка, увійдіть знову.",
  9: "Код авторизації вже використано. Спробуйте увійти ще раз.",
  10: "Помилка автентифікації системи. Зверніться до адміністратора.",
  11: "Сертифікат не відповідає вимогам. Перевірте чинність сертифіката.",
  12: "Помилка розшифрування даних. Зверніться до адміністратора.",
  100: "Користувач скасував авторизацію.",
  101: "Авторизацію відхилено. Перевірте ваші дані та спробуйте ще раз.",
  102: "Сервіс тимчасово недоступний. Спробуйте пізніше.",
  112: "Тестові сертифікати не приймаються у продуктивному середовищі.",
  900: "Не вдалося отримати дані про особу. Перевірте ваш сертифікат.",
  901: "Помилка перевірки особи. Спробуйте інший метод авторизації.",
};

// Human-readable error messages for common errors
export const ERROR_MESSAGES: Record<string, string> = {
  // Network errors
  network_error: "Помилка з'єднання з сервером. Перевірте інтернет-з'єднання.",
  server_error: "Сервер тимчасово недоступний. Спробуйте пізніше.",
  timeout: "Час очікування вичерпано. Спробуйте ще раз.",
  
  // Auth errors
  invalid_code: "Невірний код авторизації. Спробуйте увійти ще раз.",
  code_expired: "Код авторизації прострочений. Спробуйте увійти ще раз.",
  code_used: "Код авторизації вже використано. Спробуйте увійти ще раз.",
  invalid_state: "Помилка безпеки сесії. Спробуйте увійти ще раз.",
  session_expired: "Сесія авторизації закінчилась. Спробуйте увійти ще раз.",
  
  // User errors
  user_cancelled: "Ви скасували авторизацію.",
  user_blocked: "Ваш обліковий запис заблоковано. Зверніться до адміністратора.",
  access_denied: "Доступ заборонено. Зверніться до адміністратора.",
  
  // Certificate errors
  certificate_invalid: "Сертифікат недійсний або прострочений.",
  certificate_revoked: "Сертифікат відкликано.",
  certificate_not_trusted: "Сертифікат не є довіреним.",
  
  // Generic
  unknown: "Виникла невідома помилка. Спробуйте ще раз або зверніться до підтримки.",
};

export const IDGOV_VALIDATION = {
  clientId: /^[0-9A-Za-z]+$/,
  clientSecret: /^[0-9ABCDEFabcdef]+$/,
  code: /^[0-9ABCDEFabcdef]+$/,
  accessToken: /^[0-9ABCDEFabcdef]+$/,
  authType: /^[a-z_,]+$/,
  state: /^[0-9A-Za-z_-]{4,512}$/,
  drfocode: /([0-9]{10}|[АБВГДЕЄЖЗИІКЛМНОПРСТУФХЦЧШЩЮЯ]{2}[0-9]{6}|[0-9]{9})/,
} as const;

export const OAUTH_CODE_EXPIRY_SECONDS = 30;
export const AUTH_STATE_MAX_AGE_MS = 5 * 60 * 1000;
export const SESSION_STORAGE_KEY = "idgov_auth_state";
